// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._v564d86a{transition:width var(--ds--pt--ts) var(--ds--pt--te)}._1e021ssb{inset-inline-start:50%}\n._1einu2gc{border-end-end-radius:var(--ds-space-100,8px)}\n._1lww1oqq{transition-delay:var(--ds--pt--td)}\n._4t3iu2gc{height:var(--ds-space-100,8px)}\n._5fbcu2gc{border-start-end-radius:var(--ds-space-100,8px)}\n._bfhk1j1x{background-color:var(--_vcj3ew)}\n._kqswstnw{position:absolute}\n._t9ec5ihf{transform:var(--_22xnfg)}", ""]);
// Exports
module.exports = exports;
